<template>
  <IconField>
    <InputIcon>
      <AppIcon name="regular-magnifying-glass" />
    </InputIcon>
    <InputText
      ref="input"
      v-bind="$attrs"
      class="rounded-full transition-[width,max-width] duration-200 ease-in-out"
      type="text"
      :model-value="modelValue"
      :placeholder="placeholder"
      size="small"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <slot />
  </IconField>
</template>

<script>
export default { inheritAttrs: false };
</script>

<script setup>
// The one search field: pill-shaped, magnifying glass on the left (see design_system/components/
// AppSearch.vue). Width classes go straight onto the input, so callers style it as before, and a
// fixed-width caller can add a `focus:` width to make it grow. The slot takes a trailing InputIcon.
// For typeahead suggestions use SearchAutoComplete.vue instead.
import { ref } from 'vue';

defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, required: true },
});

defineEmits(['update:modelValue']);

const input = ref(null);

function focus() {
  if (input.value) input.value.$el.focus();
}

defineExpose({ focus });
</script>
